/* ================================================================
   PRODUCT DETAIL PAGE JS
================================================================ */

function initProductPage(sectionId, productId) {
  'use strict';

  var variantsData = JSON.parse(
    document.getElementById('pdp-variants-json-' + sectionId).textContent
  );
  var imagesData = JSON.parse(
    document.getElementById('pdp-images-json-' + sectionId).textContent
  );

  var form = document.querySelector('[data-pdp-form]');
  var variantInput = form ? form.querySelector('[data-pdp-variant-id]') : null;
  var priceEl = document.querySelector('[data-pdp-price-display]');
  var compareEl = document.querySelector('[data-pdp-compare]');
  var atcBtn = document.querySelector('[data-pdp-atc]');
  var mainImg = document.getElementById('pdp-main-img');
  var thumbs = document.querySelectorAll('[data-pdp-thumb]');
  var thumbsWrap = document.querySelector('.pdp-gallery__thumbs');
  var prevBtn = document.querySelector('[data-pdp-prev]');
  var nextBtn = document.querySelector('[data-pdp-next]');
  var qtyInput = document.querySelector('[data-pdp-qty]');
  var qtyDec = document.querySelector('[data-pdp-qty-dec]');
  var qtyInc = document.querySelector('[data-pdp-qty-inc]');
  var wishlistToggle = document.querySelector('[data-pdp-wishlist-toggle]');
  var wishlistProductControl = document.querySelector('.pdp-smartwishlist-product-control');
  var wishlistVariantControl = document.getElementById('smartwishlist');
  var variantChangedAt = 0;
  /* Server-rendered price, restored when the shopper drops back to the product. */
  var defaultPriceHtml = priceEl ? priceEl.innerHTML : '';
  var defaultCompareHtml = compareEl ? compareEl.innerHTML : '';


  var stickyAtcBtn = document.querySelector('[data-pdp-sticky-atc]');
  var stickyQtyDec = document.querySelector('[data-pdp-sticky-qty-dec]');
  var stickyQtyInc = document.querySelector('[data-pdp-sticky-qty-inc]');
  var stickyQtyInput = document.querySelector('[data-pdp-sticky-qty-input]');

  var selectedOptions = {};
  var currentGalleryIdx = 0;
  /* Guards the gallery <-> variant sync from re-entering itself. */
  var syncingGallery = false;
  var totalOptionGroups = 1;
  if (variantsData && variantsData.length > 0) {
    var v0 = variantsData[0];
    totalOptionGroups = ['option1', 'option2', 'option3'].filter(function (k) {
      return v0[k] !== undefined && v0[k] !== null;
    }).length;
  }

  /* ---- Resolve default variant on load ---- */
  function resolveDefaultVariant() {
    var url = new URL(window.location.href);
    var urlVariantId = url.searchParams.get('variant');
    if (urlVariantId) {
      var fromUrl = variantsData.find(function (v) {
        return String(v.id) === String(urlVariantId);
      });
      if (fromUrl) return fromUrl;
    }

    var liquidDefaultId = form
      ? (form.getAttribute('data-pdp-default-variant-id') || (variantInput ? variantInput.value : ''))
      : '';
    if (liquidDefaultId) {
      var fromLiquid = variantsData.find(function (v) {
        return String(v.id) === String(liquidDefaultId);
      });
      if (fromLiquid) return fromLiquid;
    }

    var fromActiveOptions = null;
    var activeOptions = {};
    document.querySelectorAll('.pdp-swatch.is-active, .pdp-pill.is-active').forEach(function (btn) {
      var idx = parseInt(btn.dataset.optIdx, 10);
      activeOptions[idx] = btn.dataset.optVal;
    });
    if (Object.keys(activeOptions).length > 0) {
      var previousOptions = selectedOptions;
      selectedOptions = activeOptions;
      fromActiveOptions = findVariant();
      selectedOptions = previousOptions;
    }
    if (fromActiveOptions) return fromActiveOptions;

    var firstAvailable = variantsData.find(function (v) {
      return v.available;
    });
    if (firstAvailable) return firstAvailable;

    return variantsData[0] || null;
  }

  function applyVariantSelection(variant) {
    if (!variant) return;

    ['option1', 'option2', 'option3'].forEach(function (key, optIdx) {
      if (variant[key] === undefined || variant[key] === null) return;
      markOptionSelected(optIdx, variant[key]);
    });

    updateVariant(variant);
    updateOptionAvailability();
  }

  var defaultVariant = resolveDefaultVariant();
  if (defaultVariant) {
    applyVariantSelection(defaultVariant);
  } else {
    clearUrlVariant();
    syncSmartWishlistVariant(null);
  }

  updateOptionAvailability();

  /* ---- Option click ---- */
  document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
    btn.addEventListener('click', function () {
      markOptionSelected(parseInt(btn.dataset.optIdx, 10), btn.dataset.optVal);

      var matched = findVariant();
      if (matched) {
        updateVariant(matched);
      } else {
        if (atcBtn) {
          atcBtn.disabled = true;
          atcBtn.textContent = 'CHOOSE VARIANT';
        }
        if (stickyAtcBtn) {
          stickyAtcBtn.disabled = true;
          stickyAtcBtn.textContent = 'CHOOSE VARIANT';
        }
        if (variantInput) variantInput.value = '';
        clearUrlVariant();
        syncSmartWishlistVariant(null);
      }

      updateOptionAvailability();
    });
  });

  /* Hover preview: update color label text only (no image / selection change) */
  function displayOptionLabel(val, fallbackLabel) {
    if (fallbackLabel) return fallbackLabel;
    if (!val) return '';
    return val.indexOf('_') !== -1 ? val.split('_').slice(1).join('_') : val;
  }

  function setOptSelectedText(idx, text) {
    document.querySelectorAll('[data-opt-selected="' + idx + '"]').forEach(function (el) {
      el.textContent = text ? ' ' + text : '';
    });
  }

  document.querySelectorAll('.pdp-swatch').forEach(function (btn) {
    btn.addEventListener('mouseenter', function () {
      var idx = parseInt(btn.dataset.optIdx, 10);
      if (isNaN(idx)) return;
      setOptSelectedText(
        idx,
        displayOptionLabel(btn.dataset.optVal, btn.dataset.label || btn.dataset.colorName)
      );
    });

    btn.addEventListener('mouseleave', function () {
      var idx = parseInt(btn.dataset.optIdx, 10);
      if (isNaN(idx)) return;
      var selected = selectedOptions[idx];
      if (selected) {
        var activeBtn = document.querySelector(
          '.pdp-swatch.is-active[data-opt-idx="' + idx + '"]'
        );
        setOptSelectedText(
          idx,
          displayOptionLabel(
            selected,
            activeBtn && (activeBtn.dataset.label || activeBtn.dataset.colorName)
          )
        );
      } else {
        setOptSelectedText(idx, '');
      }
    });
  });

  /* ---- Find matching variant according to business rules ---- */
  function findVariant() {
    var hasColor = selectedOptions[0] !== undefined && selectedOptions[0] !== '';
    var hasSize = selectedOptions[1] !== undefined && selectedOptions[1] !== '';

    // Color MUST be selected (mandatory)
    if (!hasColor) {
      return null;
    }

    // If both Color and Size are selected -> find exact match
    if (hasColor && (hasSize || totalOptionGroups <= 1)) {
      var exact = variantsData.find(function (v) {
        return Object.keys(selectedOptions).every(function (idxStr) {
          var optKey = 'option' + (parseInt(idxStr, 10) + 1);
          return v[optKey] === selectedOptions[idxStr];
        });
      });
      if (exact) return exact;
    }

    // If ONLY Color is selected -> pick first available variant for that Color
    if (hasColor && !hasSize) {
      var firstAvailableColor = variantsData.find(function (v) {
        return v.option1 === selectedOptions[0] && v.available;
      }) || variantsData.find(function (v) {
        return v.option1 === selectedOptions[0];
      });
      if (firstAvailableColor) return firstAvailableColor;
    }

    return null;
  }

  function updateOptionAvailability() {
    document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
      var optIdx = parseInt(btn.dataset.optIdx, 10);
      var btnVal = btn.dataset.optVal;

      var isAvailable = variantsData.some(function (v) {
        var vVal = v['option' + (optIdx + 1)];
        if (vVal !== btnVal) return false;
        if (!v.available) return false;

        return Object.keys(selectedOptions).every(function (idxStr) {
          var otherOptIdx = parseInt(idxStr, 10);
          if (otherOptIdx === optIdx) return true;
          return v['option' + (otherOptIdx + 1)] === selectedOptions[otherOptIdx];
        });
      });

      btn.classList.toggle('is-disable', !isAvailable);

      if (btn.classList.contains('pdp-swatch')) {
        var svg = btn.querySelector('svg');
        if (!isAvailable) {
          if (!svg) {
            btn.insertAdjacentHTML('beforeend', '<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M38.707 0.707153L0.707031 38.7072" stroke="#8F9AA3" stroke-width="2"/></svg>');
          }
        } else {
          if (svg) svg.remove();
        }
      }
    });
  }

  function formatMoney(cents) {
    return 'Rp' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function clearUrlVariant() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('variant')) return;
    url.searchParams.delete('variant');
    window.history.replaceState({}, '', url.toString());
  }

  function allOptionsSelected() {
    return totalOptionGroups > 0 && Object.keys(selectedOptions).length >= totalOptionGroups;
  }

  function markOptionSelected(idx, val) {
    selectedOptions[idx] = val;

    document.querySelectorAll('[data-opt-idx="' + idx + '"]').forEach(function (b) {
      var active = b.dataset.optVal === val;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-pressed', String(active));
    });

    document.querySelectorAll('[data-opt-selected="' + idx + '"]').forEach(function (el) {
      var text = val.indexOf('_') !== -1 ? val.split('_').slice(1).join('_') : val;
      el.textContent = text ? ' ' + text : '';
    });
  }

  /* Browsing back to a gallery image that belongs to no variant means the
     shopper is looking at the product again, not at a specific variant. */
  function clearVariantSelection() {
    selectedOptions = {};

    document.querySelectorAll('.pdp-swatch, .pdp-pill').forEach(function (btn) {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    });
    document.querySelectorAll('[data-opt-selected]').forEach(function (el) {
      el.textContent = '';
    });

    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.textContent = 'CHOOSE VARIANT';
    }
    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = true;
      stickyAtcBtn.textContent = 'CHOOSE VARIANT';
    }
    if (variantInput) variantInput.value = '';
    if (priceEl) priceEl.innerHTML = defaultPriceHtml;
    if (compareEl) compareEl.innerHTML = defaultCompareHtml;

    clearUrlVariant();
    syncSmartWishlistVariant(null);
    updateOptionAvailability();
  }

  /* Mirrors the app's own lookup, which compares product id and variant id and
     ignores the tuple's mode flag. */
  function isWishlistItemInCookie(productId, variantId) {
    try {
      var match = document.cookie.match(/(?:^|;\s*)bookmarkeditems=([^;]*)/);
      if (!match) return false;
      var json = JSON.parse(decodeURIComponent(match[1]));
      if (!json || !Array.isArray(json.items)) return false;
      return json.items.some(function (item) {
        return String(item[0]) === String(productId) &&
          String(item[1]) === String(variantId);
      });
    } catch (err) {
      return false;
    }
  }

  /**
   * The app identifies saved items by product id + variant id alone, so a
   * product-level entry and its first variant would collapse into one item.
   * Multi-variant products therefore require an explicit pick before the
   * wishlist toggle becomes usable.
   */
  function wishlistNeedsVariantChoice() {
    if (totalOptionGroups === 0 || variantsData.length < 2) return false;
    return !allOptionsSelected();
  }

  function syncSmartWishlistVariant(variant) {
    if (!wishlistToggle) return;

    if (wishlistNeedsVariantChoice()) {
      wishlistToggle.dataset.wishlistMode = 'blocked';
      wishlistToggle.classList.add('is-variant-required');
      wishlistToggle.classList.remove('bookmarked');
      wishlistToggle.classList.add('unbookmarked');
      wishlistToggle.setAttribute('aria-label', 'Pilih variant dulu');
      return;
    }

    wishlistToggle.classList.remove('is-variant-required');

    var explicitVariant = Boolean(variant) && allOptionsSelected();
    var fallbackId = variantsData[0] ? variantsData[0].id : '';
    var variantId = explicitVariant ? String(variant.id) : String(fallbackId || '');
    if (!variantId) return;
    var control = explicitVariant ? wishlistVariantControl : wishlistProductControl;

    if (control) {
      control.setAttribute('data-variant', variantId);
      if (window.jQuery) {
        window.jQuery(control)
          .attr('data-variant', variantId)
          .data('variant', parseInt(variantId, 10));
      }
    }

    wishlistToggle.dataset.wishlistMode = explicitVariant ? 'variant' : 'product';
    wishlistToggle.dataset.variant = variantId;
    var bookmarked = isWishlistItemInCookie(productId, variantId);
    wishlistToggle.classList.toggle('bookmarked', bookmarked);
    wishlistToggle.classList.toggle('unbookmarked', !bookmarked);
    wishlistToggle.classList.toggle('sw-removed', !bookmarked);
    wishlistToggle.setAttribute(
      'aria-label',
      bookmarked ? 'Remove from Wishlist' : 'Add to Wishlist'
    );
    if (bookmarked) {
      wishlistToggle.classList.remove('sw-removed');
    }
  }

  function triggerWishlistControl() {
    if (wishlistToggle.dataset.wishlistMode === 'blocked') {
      if (typeof window.SmartWishlistNotice === 'function') {
        window.SmartWishlistNotice('Pilih variant dulu sebelum menambahkan ke wishlist.');
      }
      return;
    }

    var explicitVariant = wishlistToggle.dataset.wishlistMode === 'variant';
    var target = explicitVariant
      ? document.getElementById('bookmarkit')
      : wishlistProductControl;

    if (!target) return;

    /* The app refreshes its private selected-variant tuple by watching the URL
       once per second. Avoid a fast post-swatch click using the previous ID. */
    var elapsed = Date.now() - variantChangedAt;
    if (explicitVariant && elapsed < 1100) {
      wishlistToggle.disabled = true;
      window.setTimeout(function () {
        wishlistToggle.disabled = false;
        target.click();
      }, 1100 - elapsed);
      return;
    }

    target.click();
  }

  function refreshWishlistToggleFromControl() {
    if (!wishlistToggle) return;
    if (wishlistToggle.dataset.wishlistMode === 'blocked') return;

    var explicitVariant = wishlistToggle.dataset.wishlistMode === 'variant';
    var target = explicitVariant
      ? document.getElementById('bookmarkit')
      : wishlistProductControl;
    if (!target) return;

    var bookmarked = explicitVariant
      ? target.getAttribute('status') === 'bookmarked' || target.classList.contains('bookmarked')
      : target.classList.contains('bookmarked');

    wishlistToggle.classList.toggle('bookmarked', bookmarked);
    wishlistToggle.classList.toggle('unbookmarked', !bookmarked);
    wishlistToggle.classList.toggle('sw-removed', !bookmarked);
    wishlistToggle.setAttribute(
      'aria-label',
      bookmarked ? 'Remove from Wishlist' : 'Add to Wishlist'
    );
  }

  if (wishlistToggle) {
    wishlistToggle.addEventListener('click', triggerWishlistControl);

    /* Account wishlists resolve asynchronously; mirror the active hidden
       control once the app injects/updates it. */
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        var appControlChanged = mutations.some(function (mutation) {
          return mutation.target !== wishlistToggle;
        });
        if (appControlChanged) refreshWishlistToggleFromControl();
      }).observe(document.querySelector('.pdp-info__wishlist-wrap'), {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'status']
      });
    }
  }

  function updateVariant(variant) {
    /* Variant ID */
    if (variantInput) variantInput.value = variant.id;

    /* Keep Smart Wishlist pointing at this exact variant + image */
    syncSmartWishlistVariant(variant);

    /* Price */
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    /* ATC availability */
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    }
    if (stickyAtcBtn) {
      stickyAtcBtn.disabled = !variant.available;
      stickyAtcBtn.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
    }

    /* URL update without reload */
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
    variantChangedAt = Date.now();

    /* Sync gallery to variant featured image */
    if (variant.featured_image && variant.featured_image.position) {
      var imgIdx = variant.featured_image.position - 1;
      if (imgIdx >= 0 && imgIdx < imagesData.length) {
        setGalleryImage(imgIdx);
      }
    }
  }

  /* ---- Gallery ---- */
  function keepThumbInView(thumb) {
    if (!thumbsWrap || !thumb) return;

    var targetLeft = thumb.offsetLeft - (thumbsWrap.clientWidth - thumb.offsetWidth) / 2;
    thumbsWrap.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: 'smooth'
    });
  }

  function variantImageIndex(variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.position) return -1;
    return variant.featured_image.position - 1;
  }

  function variantForImageIndex(idx) {
    for (var i = 0; i < variantsData.length; i++) {
      if (variantImageIndex(variantsData[i]) === idx) return variantsData[i];
    }
    return null;
  }

  /**
   * Keeps swatches in step with the gallery. Returns true when the selection
   * change already redrew the gallery, so the caller can skip doing it twice.
   */
  function syncSelectionToGalleryImage(idx) {
    var current = allOptionsSelected() ? findVariant() : null;
    if (current && variantImageIndex(current) === idx) return false;

    var galleryVariant = variantForImageIndex(idx);
    if (!galleryVariant) {
      if (Object.keys(selectedOptions).length > 0) clearVariantSelection();
      return false;
    }

    ['option1', 'option2', 'option3'].forEach(function (key, optIdx) {
      if (galleryVariant[key] === undefined || galleryVariant[key] === null) return;
      markOptionSelected(optIdx, galleryVariant[key]);
    });

    syncingGallery = true;
    updateVariant(galleryVariant);
    syncingGallery = false;
    updateOptionAvailability();
    return true;
  }

  function setGalleryImage(idx) {
    if (!imagesData[idx]) return;
    if (!syncingGallery && syncSelectionToGalleryImage(idx)) return;

    currentGalleryIdx = idx;
    if (mainImg) {
      // Fade out
      mainImg.style.opacity = '0';

      // Wait for CSS transition (200ms) before swapping src
      setTimeout(function () {
        mainImg.src = imagesData[idx].src;
        mainImg.alt = imagesData[idx].alt;

        // Fade back in when the new image is fully loaded
        mainImg.onload = function () {
          mainImg.style.opacity = '1';
        };
        // Fallback for cached images that might not fire onload
        if (mainImg.complete) {
          mainImg.style.opacity = '1';
        }
      }, 200);
    }
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === idx);
    });
    if (thumbs[idx]) {
      keepThumbInView(thumbs[idx]);
    }
  }

  thumbs.forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () { setGalleryImage(idx); });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () {
    setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
  });
  if (nextBtn) nextBtn.addEventListener('click', function () {
    setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
  });

  /* ---- Touch Swipe Gesture for Mobile Gallery ---- */
  var galleryMainContainer = document.querySelector('.pdp-gallery__main');
  if (galleryMainContainer) {
    var touchStartX = 0;
    var touchEndX = 0;

    galleryMainContainer.addEventListener('touchstart', function (e) {
      if (e.changedTouches && e.changedTouches.length > 0) {
        touchStartX = e.changedTouches[0].screenX;
      }
    }, { passive: true });

    galleryMainContainer.addEventListener('touchend', function (e) {
      if (e.changedTouches && e.changedTouches.length > 0) {
        touchEndX = e.changedTouches[0].screenX;
        var diffX = touchEndX - touchStartX;
        if (Math.abs(diffX) > 35 && imagesData && imagesData.length > 1) {
          if (diffX < 0) {
            // Swipe Left -> Next Image
            setGalleryImage((currentGalleryIdx + 1) % imagesData.length);
          } else {
            // Swipe Right -> Previous Image
            setGalleryImage((currentGalleryIdx - 1 + imagesData.length) % imagesData.length);
          }
        }
      }
    }, { passive: true });
  }

  /* ---- Quantity stepper syncing ---- */
  function syncQty(val) {
    if (qtyInput) qtyInput.value = val;
    if (stickyQtyInput) stickyQtyInput.value = val;
  }

  if (qtyDec) qtyDec.addEventListener('click', function () {
    var v = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    syncQty(Math.max(1, v - 1));
  });
  if (qtyInc) qtyInc.addEventListener('click', function () {
    var v = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
    syncQty(Math.min(99, v + 1));
  });

  if (stickyQtyDec) stickyQtyDec.addEventListener('click', function () {
    var v = parseInt(stickyQtyInput ? stickyQtyInput.value : 1, 10) || 1;
    syncQty(Math.max(1, v - 1));
  });
  if (stickyQtyInc) stickyQtyInc.addEventListener('click', function () {
    var v = parseInt(stickyQtyInput ? stickyQtyInput.value : 1, 10) || 1;
    syncQty(Math.min(99, v + 1));
  });

  if (stickyAtcBtn && atcBtn) {
    stickyAtcBtn.addEventListener('click', function () {
      if (stickyAtcBtn.disabled) return;
      atcBtn.click();
    });
  }

  /* ---- Add to Cart ---- */
  if (atcBtn) {
    atcBtn.addEventListener('click', function () {
      if (!variantInput || !variantInput.value) return;
      var qty = parseInt(qtyInput ? qtyInput.value : 1, 10) || 1;
      atcBtn.classList.add('is-loading');
      atcBtn.disabled = true;
      if (stickyAtcBtn) {
        stickyAtcBtn.classList.add('is-loading');
        stickyAtcBtn.disabled = true;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) {
            return r.text().then(function (text) {
              var data = null;
              try { data = JSON.parse(text); } catch (e) { }
              throw new Error(data && data.description ? data.description : 'Could not add to cart.');
            });
          }
          return r;
        })
        .then(function () {
          if (window.BohopanaCart && typeof window.BohopanaCart.refreshFromCart === 'function') {
            window.BohopanaCart.refreshFromCart({ showNotice: true });
          } else {
            updateCartCount();
          }
          atcBtn.textContent = 'ADDED!';
          if (stickyAtcBtn) stickyAtcBtn.textContent = 'ADDED!';

          setTimeout(function () {
            atcBtn.textContent = 'ADD TO BAG';
            if (stickyAtcBtn) stickyAtcBtn.textContent = 'ADD TO BAG';
          }, 1800);
        })
        .catch(function () { alert('Could not add to cart. Please try again.'); })
        .finally(function () {
          atcBtn.classList.remove('is-loading');
          atcBtn.disabled = false;
          if (stickyAtcBtn) {
            stickyAtcBtn.classList.remove('is-loading');
            stickyAtcBtn.disabled = false;
          }
        });
    });
  }

  /* ---- Hide Sticky Bar when native inline ATC button is visible on screen, EXCEPT on initial landing ---- */
  var stickyBar = document.querySelector('.pdp-sticky-bar');
  if (atcBtn && stickyBar) {
    function checkStickyVisibility() {
      var scrollY = window.scrollY || window.pageYOffset || 0;
      var rect = atcBtn.getBoundingClientRect();

      // State 1: Landing / top of page -> ALWAYS SHOW sticky bar
      if (scrollY < 120) {
        stickyBar.classList.remove('is-hidden');
        return;
      }

      // State 2: Native inline button is visible on screen -> HIDE sticky bar to avoid double
      var isNativeBtnInView = (rect.top < (window.innerHeight - 20)) && (rect.bottom > 20);
      if (isNativeBtnInView) {
        stickyBar.classList.add('is-hidden');
      } else {
        // State 3: Scrolled past native inline button (down to description/reviews/footer) -> SHOW sticky bar
        stickyBar.classList.remove('is-hidden');
      }
    }

    window.addEventListener('scroll', checkStickyVisibility, { passive: true });
    window.addEventListener('resize', checkStickyVisibility, { passive: true });
    checkStickyVisibility();
  }

  function updateCartCount() {
    if (window.BohopanaCart && typeof window.BohopanaCart.refreshFromCart === 'function') {
      return window.BohopanaCart.refreshFromCart();
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header-action-btn__badge').forEach(function (badge) {
          badge.textContent = cart.item_count > 0 ? '+' + cart.item_count : '';
          badge.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }



  /* ---- Accordion ---- */
  document.querySelectorAll('.pdp-accordion__trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var item = trigger.closest('.pdp-accordion__item');
      var body = item.querySelector('.pdp-accordion__body');
      var isOpen = item.classList.contains('is-open');

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
      if (!isOpen) {
        body.removeAttribute('hidden');
      } else {
        body.setAttribute('hidden', '');
      }
    });
  });

  /* ---- Product Recommendations (YMAL) ---- */
  var recsWrap = document.querySelector('[data-recommendations-url]');
  if (recsWrap) {
    var recsUrl = recsWrap.dataset.recommendationsUrl;
    fetch(recsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var track = doc.querySelector('.scroll-row--md, .product-grid, .products-grid');
        var recsContainer = document.getElementById('pdp-recs-' + sectionId);
        if (track && recsContainer) {
          recsContainer.innerHTML = track.innerHTML;
        }
      })
      .catch(function () { });
  }

  /* ---- Size Guide Popup ---- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-size-guide-trigger]');
    if (trigger) {
      e.preventDefault();
      var popup = document.getElementById('size-guide-popup');
      if (popup) {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }

    var closeBtn = e.target.closest('[data-size-guide-close]');
    if (closeBtn) {
      e.preventDefault();
      var popup = document.getElementById('size-guide-popup');
      if (popup) {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var popup = document.getElementById('size-guide-popup');
      if (popup && popup.classList.contains('is-open')) {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });
}
